import { render, staticRenderFns } from "./StatisticalIndex.vue?vue&type=template&id=fab0e9fc"
import script from "./StatisticalIndex.vue?vue&type=script&lang=js"
export * from "./StatisticalIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports